export enum EventStatus {
  PRECREATE = -1,
  DRAFT = 0,
  ACTIVATED,
  CLOSED,
}
